var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.619,
    height: 82.577,
    viewBox: "0 0 94.619 82.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(0.782 -1.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37523",
    "data-name": "Path 37523",
    d: "M39.291,8.418,3.462,68.232A8.46,8.46,0,0,0,10.7,80.923H82.354a8.46,8.46,0,0,0,7.234-12.69L53.758,8.418a8.46,8.46,0,0,0-14.467,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#de0a0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37524",
    "data-name": "Path 37524",
    d: "M18,13.5V30.421",
    transform: "translate(28.524 16.661)",
    fill: "none",
    stroke: "#de0a0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37525",
    "data-name": "Path 37525",
    d: "M18,25.5h0",
    transform: "translate(28.524 38.502)",
    fill: "none",
    stroke: "#de0a0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red_alert.3dfa96d8c93b859a86b13c630aab859c.svg";
export { ForwardRef as ReactComponent };